// Adapted version of your ModalAssignment to include Dnd Kit
import React, { useEffect, useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { IoIosSave } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaInfoCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setForm, resetForm } from "redux/assignment.slice";
import { notify, formatDate } from "utils";
import { saveAssignment } from "actions/Assignment";
import { RxDragHandleDots2 } from "react-icons/rx";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import toast from "react-hot-toast";

const SortableRow = ({ row, index, handleDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: row.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className="border border-gray-200 hover:bg-gray-50"
    >
      <td className="px-4 py-2">
        <div
          {...attributes}
          {...listeners}
          className="cursor-move gap-3 flex justify-start items-center"
        >
          <RxDragHandleDots2 />
          {index + 1}
        </div>
      </td>
      <td className="px-4 py-2">{row.carrierString}</td>
      <td className="px-4 py-2">{row.id}</td>
      <td className="px-4 py-2">{row.shPt}</td>
      <td className="px-4 py-2 flex items-center gap-2">
        {row.shipTo}
        <div className="relative group">
          <FaInfoCircle className="w-4 h-4 text-gray-500 cursor-pointer" />
          <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 w-48 p-2 text-xs bg-gray-700 text-white rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
            Dirección Completa del Destino
            <br /> (Hasta Estado)
          </div>
        </div>
      </td>
      <td className="px-4 py-2">{formatDate(row.pU_AppointmentDay)}</td>
      <td className="px-4 py-2">{row.pU_AppointmentTime}</td>
      <td className="px-4 py-2 text-center">
        <MdDelete
          onClick={() => handleDelete(row.id)}
          className="w-4 h-4 text-red-500 cursor-pointer hover:text-red-700"
        />
      </td>
    </tr>
  );
};

const ModalAssignment = ({ isOpen, onClose, getAppointmentsFn }) => {
  const [t] = useTranslation("planning");
  const [showModal, setShowModal] = useState(false);
  const [tmpSelected, setTmpSelected] = useState([]);
  const { appointmentsSelected, form, trucks, drivers } = useSelector(
    (state) => state.assignment
  );
  const { currentProject } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const sensors = useSensors(useSensor(PointerSensor));

  useEffect(() => {
    setTmpSelected(appointmentsSelected);
  }, [appointmentsSelected, isOpen]);

  const handleDelete = (id) => {
    const updatedSelected = tmpSelected.filter((item) => item.id !== id);
    if (updatedSelected.length === 0)
      return notify("warning", "Minimo 1 cita", 3000);
    toast.success(`Se eliminó la cita con el id ${id}`, {
      duration: 3000,
      position: "top-right",
    });
    setTmpSelected(updatedSelected);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = tmpSelected.findIndex((item) => item.id === active.id);
      const newIndex = tmpSelected.findIndex((item) => item.id === over.id);
      setTmpSelected((items) => arrayMove(items, oldIndex, newIndex));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setForm({ ...form, [name]: value }));
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const isAppointmentOrderValid = (arr) => {
    const appointmentDates = arr.map((item) => {
      const datePart = item.pU_AppointmentDay.split("T")[0];
      const fullDateTime = `${datePart}T${item.pU_AppointmentTime}`;
      const date = new Date(fullDateTime);

      if (isNaN(date.getTime())) {
        console.error("Fecha inválida:", fullDateTime);
      }

      return date;
    });

    for (let i = 1; i < appointmentDates.length; i++) {
      if (appointmentDates[i - 1] > appointmentDates[i]) {
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    if (isLoading) return;
    if (!form.idTruck || form.idTruck === "0")
      return notify("warning", t("errorsRequired.unit"), 3000);
    if (!form.idDriver || form.idDriver === "0")
      return notify("warning", t("errorsRequired.operator"), 3000);
    if (!form.observations)
      return notify("warning", t("errorsRequired.observation"), 3000);

    debugger;
    const isValid = isAppointmentOrderValid(tmpSelected);
    if (!isValid) {
      return notify(
        "error",
        "Las citas deben estar ordenadas por fecha y hora",
        3000
      );
    }
    const data = {
      idCarrier: tmpSelected[0].carrierId,
      idTruck: form.idTruck,
      idOperator: form.idDriver,
      idProject: currentProject.id,
      comments: form.observations,
      detailsShipmentPlan: tmpSelected.map((item) => item.id),
    };

    setIsLoading(true);
    const result = await dispatch(saveAssignment(data));
    setIsLoading(false);
    if (result) {
      notify("success", t("planAssignment.saveSuccess"), 3000);
      getAppointmentsFn();
      onClose();
    }
  };

  const handleClose = () => {
    dispatch(resetForm());
    onClose();
  };

  console.log(tmpSelected);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white overflow-y-auto rounded-xl shadow-lg w-full max-w-7xl h-[60vh] relative transition-all duration-300 transform ${
          showModal ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
      >
        <div className="h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg">
          <span className="text-white font-[Gravity] text-2xl font-bold">
            {t("planAssignment.modalTitle")}
          </span>
          <div className="flex flex-row space-x-2">
            {isLoading ? (
              <div className="pt-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              </div>
            ) : (
              <div className="w-8 h-8 flex justify-center items-center bg-gray-600 rounded-full p-1 text-white text-4xl cursor-pointer">
                <IoIosSave onClick={handleSave} />
              </div>
            )}
            <IoCloseCircleOutline
              onClick={handleClose}
              className="text-white text-4xl cursor-pointer"
            />
          </div>
        </div>
        <div className="p-6 space-y-6 lg:px-10 sm:px-0">
          <div className="overflow-x-auto">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={tmpSelected.map((item) => item.id)}
                strategy={verticalListSortingStrategy}
              >
                <table className="w-full border-collapse rounded-lg overflow-hidden">
                  <thead className="bg-black text-white text-sm pb-2">
                    <tr>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.mColumOrder")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.service")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.mColumId")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.columnOrigen")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.mColunDestination")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.mColumDate")}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {t("planAssignment.mColumHour")}
                      </th>
                      <th className="px-4 py-2"></th>
                    </tr>
                  </thead>
                  <tbody className="text-lg bg-white">
                    {tmpSelected.map((row, index) => (
                      <SortableRow
                        key={row.id}
                        row={row}
                        index={index}
                        handleDelete={handleDelete}
                      />
                    ))}
                  </tbody>
                </table>
              </SortableContext>
            </DndContext>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block mb-1 font-semibold">
                {t("planAssignment.unit")}:
              </label>
              <select
                name="idTruck"
                onChange={handleChange}
                value={form.idTruck}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value={0}>Selecciona una opción</option>
                {trucks.map((truck) => (
                  <option key={truck.id} value={truck.id}>
                    {truck.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block mb-1 font-semibold">
                {t("planAssignment.operator")}:
              </label>
              <select
                name="idDriver"
                onChange={handleChange}
                value={form.idDriver}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value={0}>Selecciona una opción</option>
                {drivers.map((driver) => (
                  <option key={driver.id} value={driver.id}>
                    {driver?.user?.name ?? ""} {driver?.user?.lastName ?? ""}{" "}
                    {driver?.user?.secondLastName ?? ""}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <label className="block font-semibold">
            {t("planAssignment.observations")}:
          </label>
          <textarea
            maxLength={600}
            name="observations"
            onChange={handleChange}
            value={form.observations}
            className="w-full p-2 border border-gray-300 rounded h-32"
          />
        </div>
      </div>
    </div>
  );
};

export default ModalAssignment;
